/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { useWheel } from './useWheel';
import { zoom, ZOOM_INCREMENT } from '../utils/zoomUtils';

type UseWheelZoomOptions = {
  zooming: 'on' | 'off';
  minZoom: number;
  maxZoom: number;
  zoomValue: number;
  onZoom?: (detail: { zoomValue: number }) => void;
};

const useWheelZoom = ({ zooming, minZoom, maxZoom, zoomValue, onZoom }: UseWheelZoomOptions) => {
  const wheelProps = useWheel({
    onWheel: ({ deltaY }) => {
      const newZoom = zoomValue * (1 + ZOOM_INCREMENT * deltaY);
      zoom(newZoom, zoomValue, minZoom, maxZoom, onZoom);
    },
    isDisabled: zooming === 'off'
  });

  return wheelProps;
};

export { useWheelZoom };
